/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      // $( '.testimonial-slider-outer' ).slick( {
      //   infinite: true,
      //   dots: true,
      //   arrows: true,
      //   slidesToShow: 2,
      //   slidesToScroll: 1,
      //   nextArrow: '#testimonial-previous',
      //   prevArrow: '#testimonial-next',

      // } );

      const nextBtn = document.querySelector( '#testimonial-next' );
      const prevBtn = document.querySelector( '#testimonial-prev' );
      const slides = document.querySelectorAll( '.testimonial-card-wrapper' );

      let index = 0;

      nextBtn.addEventListener( 'click', () => {
        prevBtn.classList.remove( 'inactive' );

        slides.forEach( ( slide ) => {
          slide.classList.remove( 'move-in-back' );
          slide.classList.remove( 'move-out-back' );
        } );

        // CURRENT SLIDE MOVES OUT
        slides[index].classList.remove( 'move-in' );
        slides[index].classList.remove( 'front' );
        slides[index].classList.add( 'move-out' );
        slides[index].classList.add( 'out' );

        index++;

        // NEXT SLIDE MOVES IN
        slides[index].classList.remove( 'behind' );
        slides[index].classList.add( 'front' );
        slides[index].classList.add( 'move-in' );

        // PREVIOUS SLIDE MOVES IN
        if ( slides.length !== index+1 ) {
          slides[index+1].classList.remove( 'move-out' );
          slides[index+1].classList.remove( 'out' );
          slides[index+1].classList.add( 'behind' );
        } else {
          nextBtn.classList.add( 'inactive' );
        }
      } );

      prevBtn.addEventListener( 'click', () => {
        nextBtn.classList.remove( 'inactive' );

        slides.forEach( ( slide ) => {
          slide.classList.remove( 'move-in' );
          slide.classList.remove( 'move-out' );
        } );

        // OUT SLIDE MOVES FRONT
        if ( slides.length !== index-1 ) {
          slides[index-1].classList.add( 'move-out-back' );
          slides[index-1].classList.remove( 'move-in-back' );
          slides[index-1].classList.add( 'front' );
          slides[index-1].classList.remove( 'out' );
        }

        // CURRENT SLIDE MOVES BEHIND
        slides[index].classList.add( 'behind' );
        slides[index].classList.remove( 'move-out-back' );
        slides[index].classList.add( 'move-in-back' );
        slides[index].classList.remove( 'front' );

        // BEHIND GOES OUT
        if ( slides.length !== index+1 ) {
          slides[index+1].classList.remove( 'behind' );
          slides[index+1].classList.remove( 'front' );
          // slides[index+1].classList.remove( 'move-in-back' );
          slides[index+1].classList.add( 'out' );
        }

        index--;

        if ( index===0 ) {
          prevBtn.classList.add( 'inactive' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
